/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit EditNoteDialog/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function EditNoteDialog({
  children,
  viewPath = "/DesignSystem/TimeGrid/FullCalendarTimegrid/Note/EditNoteDialog",
  contentRef,
  top,
  left,
  onClose
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
 contentRef={contentRef}
 top={top}
 left={left}
 onClose={onClose}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}